import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));
export default function Java_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const CustomExpandIcon = ({ isExpanded }) => (
    <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
      {isExpanded ? "−" : "+"}
    </span>
  );
  return (
    <div className={classes.root} style={{ width: '85%', margin: '0 auto' }}>
      <Accordion
        className="py-2"
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel1"} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Introduction to JAVA 
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           Overview and features of Java programming language, Java architecture, JDK/JVM/JRE overview, discussion on source code and bytecode, “Hello World” program, editors and Eclipse IDE.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel2"} />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Basics of JAVA Programming Language
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Data types and variables, keywords in Java, common operators, primitive datatypes, strings, data type casting (widening & narrowing conversions), loops (for, while), switch case and if blocks, and basic programs using learned concepts.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel3"} />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Methods / Functional Programming in JAVA
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Overview of methods and classes, industry standards, method declaration structure, method call types and return types, method parameters and scope, static methods, introduction to static keyword, packages, and static imports.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel4"} />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Arrays and Strings
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Introduction to arrays, properties and functionality, string methods and properties, mutable vs immutable strings, string buffer and builder, command-line arguments using args[], and basic programs on arrays and strings.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel5"} />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            OOPs (Object-Oriented Programming)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Overview, need and benefits of OOP, pillars of OOP, “new” keyword, discussion on heap memory and garbage collector, constructors, super and this keywords, and “static” keyword w.r.t OOP.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel6"} />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
            Pillar 1: Encapsulation
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Access modifiers, setters and getters, and final keyword usage.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary
          expandIcon={<CustomExpandIcon isExpanded={expanded === "panel7"} />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography style={{ fontSize: "1.2rem" }}>
          Pillar 2: Inheritance
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Importance and types of inheritance (single, multi-level, hierarchical), super keyword w.r.t inheritance, access modifiers, and intro to Object class methods.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion 
          className="py-2"
          expanded={expanded === "panel8"}
          onChange={handleChange("panel8")}
           >
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel8"} />}
    aria-controls="panel8bh-content"
    id="panel8bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Pillar 1: Encapsulation
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Access modifiers, setters and getters, and final keyword usage.
    </Typography>
  </AccordionDetails>
</Accordion>

<Accordion 
  className="py-2"
  expanded={expanded === "panel9"}
  onChange={handleChange("panel9")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel9"} />}
    aria-controls="panel9bh-content"
    id="panel9bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
       Pillar 2: Inheritance
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Importance and types of inheritance (single, multi-level, hierarchical), super keyword w.r.t inheritance, access modifiers, and intro to Object class methods.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel10"}
  onChange={handleChange("panel10")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel10"} />}
    aria-controls="panel10bh-content"
    id="panel10bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
       Pillar 3: Polymorphism
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Method overloading and overriding, runtime and compile-time polymorphism, overriding toString and equals methods, and @Override annotation.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel11"}
  onChange={handleChange("panel11")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel11"} />}
    aria-controls="panel11bh-content"
    id="panel11bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
       Pillar 4: Abstraction
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Abstract keyword, difference between concrete and abstract methods, interfaces, marker interface, functional interfaces, lambda expressions, and inner classes.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel12"}
  onChange={handleChange("panel12")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel12"} />}
    aria-controls="panel12bh-content"
    id="panel12bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Exception Handling
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Exceptions and errors, exception class hierarchy, try/catch/finally, try-with-resources, throw/throws keywords, default exception handler, custom exception handlers, corner cases, and best practices.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel13"}
  onChange={handleChange("panel13")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel13"} />}
    aria-controls="panel13bh-content"
    id="panel13bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Collection Framework
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Collection interface hierarchy, ArrayList, LinkedList, Set, Map, iterators, fail-safe and fail-fast iteration, comparator and comparable usage, purpose of collection classes, and HashMap.
    </Typography>
  </AccordionDetails>
</Accordion>

<Accordion 
  className="py-2"
  expanded={expanded === "panel14"}
  onChange={handleChange("panel14")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel14"} />}
    aria-controls="panel14bh-content"
    id="panel14bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
       File Handling and I/O
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Learn about various file types, their usage, file operations using Java, InputStream and OutputStream, reading and writing text files using streams, and serialization & deserialization best practices.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel15"}
  onChange={handleChange("panel15")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel15"} />}
    aria-controls="panel15bh-content"
    id="panel15bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
       Multi-Threading
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Parallel processing and its advantages, Thread class and Runnable interface, thread pool, thread states and lifecycle, deadlock, concurrency and thread safety, synchronization, and volatile keyword for visibility.
    </Typography>
  </AccordionDetails>
</Accordion>
<Accordion 
  className="py-2"
  expanded={expanded === "panel16"}
  onChange={handleChange("panel16")}
>
  <AccordionSummary
    expandIcon={<CustomExpandIcon isExpanded={expanded === "panel16"} />}
    aria-controls="panel16bh-content"
    id="panel16bh-header"
  >
    <Typography style={{ fontSize: "1.2rem" }}>
      Minor & Major Project
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Apply your learning through a Minor Project with small-scale programs and a Major Project involving a full-scale Java application demonstrating practical implementation of all concepts.
    </Typography>
  </AccordionDetails>
</Accordion>
{!showMore && (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowMore(true)}
            style={{
              fontWeight: "600",
              fontSize: "1rem",
              textTransform: "none",
              borderRadius: "8px",
            }}
          >
            + Show More
          </Button>
        </div>
      )}
      {/* ---- Skill Development Section ---- */}
      {showMore && (
        <div style={{ marginTop: "3rem" }}>
          <Typography
            variant="h5"
            style={{
              textAlign: "center",
              marginBottom: "0.5rem",
               fontWeight: "500",
              color: "#2b1c50",              
              fontSize: "2.5rem",
              userSelect: "none",              
            }}
          >
            Skill Development            
          </Typography>         
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              color: "var(--color-grey-darken-2)",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "0.9rem",
              maxWidth: "1000px",
              margin: "0 auto 2rem", 
              lineHeight: "1.8",
              userSelect: "none",
           }}
           >
          Boost your confidence, build job-ready skills, and get professional exposure with our practical, mentor-led sessions.
          </Typography>
          
          <Accordion expanded={expanded === "skill1"} onChange={handleChange("skill1")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill1"} />}
              aria-controls="skill1-content"
              id="skill1-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Ace Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
             <Typography>
             Master the art of first impressions! Understand professional dressing, confident body language, and effective communication to impress interviewers in both online and offline settings.           
          </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill2"} onChange={handleChange("skill2")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill2"} />}
              aria-controls="skill2-content"
              id="skill2-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Prepare Professionally
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Get ready like a pro! Know what documents to carry, how to handle online connectivity, and maintain etiquette throughout your interview process.
              </Typography>
            </AccordionDetails>
          </Accordion>
          
          <Accordion expanded={expanded === "skill3"} onChange={handleChange("skill3")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill3"} />}
              aria-controls="skill3-content"
              id="skill3-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn to Build an ATS-Optimized Resume
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Create a standout resume that passes recruiter screening. Learn about ATS keywords, structure, and impactful statements that highlight your achievements effectively.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill4"} onChange={handleChange("skill4")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill4"} />}
              aria-controls="skill4-content"
              id="skill4-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn How Recruiters Screen Resumes
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Get insider insights into how HRs and recruiters shortlist candidates. Understand what they look for and tailor your resume for better visibility.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill5"} onChange={handleChange("skill5")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill5"} />}
              aria-controls="skill5-content"
              id="skill5-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn LinkedIn Profile Optimization
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              Build a powerful LinkedIn profile that attracts recruiters. Learn how to grow your network, attempt skill assessments, and apply for relevant job or internship opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill6"} onChange={handleChange("skill6")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill6"} />}
              aria-controls="skill6-content"
              id="skill6-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                 Learn Post-Interview Strategies
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Know what to do after your interview — from handling feedback to understanding different interview types, consultancies, and HR connections for future opportunities.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill7"} onChange={handleChange("skill7")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill7"} />}
              aria-controls="skill7-content"
              id="skill7-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Workplace & Office Etiquette
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Step into the corporate world confidently! Learn workplace ethics, POSH guidelines, onboarding checks, and professional behavior to thrive in any environment.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill8"} onChange={handleChange("skill8")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill8"} />}
              aria-controls="skill8-content"
              id="skill8-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Effective Communication & Ethics
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
               Develop soft skills that matter — clear communication, gesture control, and maintaining professionalism in every conversation and meeting.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "skill9"} onChange={handleChange("skill9")}>
            <AccordionSummary
              expandIcon={<CustomExpandIcon isExpanded={expanded === "skill9"} />}
              aria-controls="skill9-content"
              id="skill9-header"
              style={{ minHeight: '70px' }}
            >
              <Typography style={{ fontSize: "1.2rem" }}>
                Learn Through Real HR Mock Interviews
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Gain hands-on experience with mock interview practice sessions conducted by real Talent Acquisition professionals.
                Get personalized feedback, understand real interview dynamics, and improve your confidence before stepping into actual interviews.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </div>
  );
}


